module.exports = __webpack_public_path__ + "static/media/mobileMainLogoEng.28d5358f.jpeg";